import { z } from 'zod';

import {
    createDeleteSchema,
    createUpdateSchemaFromAdd,
    optionalBoolean,
    optionalNumber,
    optionalString,
    optionalUuid,
    requiredNumber,
    requiredUuid,
} from './fields';
import { SYNC_UPDATE_VALIDATION_SCHEMA } from './common';

export const createOrganisationsAddSchema = () =>
    z.object({
        id: requiredUuid(),
        created_at: requiredNumber(),
        updated_at: requiredNumber(),
        name: optionalString(),
        location_id: optionalUuid(),
        owner_id: optionalUuid(),
        address: optionalString(),
        alternative_address: optionalString(),
        payment_instructions: optionalString(),
        phone_number: optionalString(),
        email: optionalString(),
        alternative_email: optionalString(),
        alternative_phone_number: optionalString(),
        alternative_phone_prefix: optionalString(),
        footer_message: optionalString(),
        tax_rate: optionalString(),
        products_tax_rate: optionalString(),
        business_number: optionalString(),
        phone_prefix: optionalString(),
        is_alternative_phone_enabled: optionalBoolean(),
        is_alternative_email_enabled: optionalBoolean(),
        default_invoice_due_days: optionalNumber(),
    });

export const createOrganisationsUpdateSchema = () =>
    createUpdateSchemaFromAdd(
        createOrganisationsAddSchema(),
        SYNC_UPDATE_VALIDATION_SCHEMA.organisations,
    );

export const createOrganisationsDeleteSchema = () => createDeleteSchema();

export const createOrganisationsSchemas = () => ({
    add: createOrganisationsAddSchema(),
    update: createOrganisationsUpdateSchema(),
    delete: createOrganisationsDeleteSchema(),
});
